var JpHeartsTireSearchJs = (function ($) {

    var removeSelectBoxesContent = function( selectBoxList ){
        for(var selectBoxId in selectBoxList){
            $(selectBoxList[selectBoxId]).find('option:gt(0)').remove();
            $(selectBoxList[selectBoxId]).prop('disabled', true);
            $(selectBoxList[selectBoxId]+' option:first-child').prop("selected", true);
        }
    };


    var displayErrorDiv = function(){
        $(".jp-hearts-tire-search-error-div").show();
    };

    var showSpinner = function(element) {
        element.parent().append('<i class="hearts-spinner fa fa-spinner fa-spin fa-1x fa-fw"></i>');
    };

    var hideSpinner = function () {
        $('.hearts-spinner').remove();
    }

    var init = function() {
        loadCarManufacturers();
        addMakerSelectorHandler();
        addCarSelectorHandler();
        addTyreSelectorHandler();
    }

    var loadCarManufacturers = function(){
        showSpinner($('#jp-hearts-tire-search-maker-selector'));
        $.ajax({
            type : 'GET',
            url : contextPath + "/ws/jp/hearts/maker/search",
            success : function(data) {
                if (data){
                    $("#jp-hearts-tire-search-maker-selector").prop('disabled',
                            false).trigger("focus");
                    for ( var i in data) {
                        $("#jp-hearts-tire-search-maker-selector").append(
                                "<option value='" + data[i].id + "'>" + data[i].name + "</option>");
                    }
                };
                hideSpinner();
            },
            error:  function(xhr, ajaxOptions, thrownError) {
                hideSpinner();
                displayErrorDiv();
            }
        });
    }

    var addMakerSelectorHandler = function(){
        $('#jp-hearts-tire-search-maker-selector').on('change',function() {

            showSpinner($('#jp-hearts-tire-search-car-selector'));
            var makerId = $("#jp-hearts-tire-search-maker-selector option:selected").val();
            removeSelectBoxesContent(['#jp-hearts-tire-search-car-selector','#jp-hearts-tire-search-tyre-selector']);
            $("#carselector-hearts-default-submit").prop('disabled', true);
            $.ajax({
                type : 'GET',
                url : contextPath + "/ws/jp/hearts/car/search?makerId=" + makerId,
                success : function(data) {
                    if (data){
                        $("#jp-hearts-tire-search-car-selector").prop('disabled',
                                false).trigger("focus");
                        for ( var i in data) {
                            $("#jp-hearts-tire-search-car-selector").append(
                                    "<option value='" + data[i].car_id + "'>"
                                            + data[i].car+" "+data[i].model+" "+ data[i].year + yearTranslation+ "</option>");
                        }
                    }
                    hideSpinner();
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    hideSpinner();
                   displayErrorDiv();
                }
            });
        });
    }

    var addCarSelectorHandler= function() {
        $('#jp-hearts-tire-search-car-selector').on('change',function() {
            showSpinner($('#jp-hearts-tire-search-tyre-selector'));
            var carId = $("#jp-hearts-tire-search-car-selector option:selected").val();
            removeSelectBoxesContent(['#jp-hearts-tire-search-tyre-selector']);
            $("#carselector-hearts-default-submit").prop('disabled', true);
            $.ajax({
                type : 'GET',
                url : contextPath + "/ws/jp/hearts/tyre/search?carId="+ carId,
                success : function(data) {
                    if (data){
                        $("#jp-hearts-tire-search-tyre-selector").prop('disabled', false)
                                .trigger("focus");
                        for ( var i in data) {
                            $("#jp-hearts-tire-search-tyre-selector").append(
                                    "<option value='" + handleNullValue(data[i].width) + "|" + handleNullValue(data[i].profile) + "|" + handleNullValue(data[i].size) + "|" + handleNullValue(data[i].speedRating) + "'>" + data[i].label
                                            + "</option>");
                        }
                    };
                    hideSpinner();
                },
                error : function(xhr, ajaxOptions, thrownError) {
                    hideSpinner();
                    displayErrorDiv();
                }
            });
          }
        );

     };

    var addTyreSelectorHandler = function() {
        $('#jp-hearts-tire-search-tyre-selector').on('change',function() {

                if (this.value != '') {
                    populateForm($(this).val());
                    $("#carselector-hearts-default-submit").prop('disabled', false);
                } else{
                    $("#carselector-hearts-default-submit").prop('disabled', true);
                }
            }
        );
    };
 	var populateForm = function(data) {
		var values = data.split("|"); // split by pipe creates individual values
		var formValues = {
			width: values[0],
			profile: values[1],
			size: values[2],
			speedRating: values[3]
		};
		for (var key in formValues) {
			$("#jpHeartsSearchForm input[name='" + key +"']").val(formValues[key]);
		}
    };
    var handleNullValue = function(data) {
        if (data==null){
            return '';
        }
        return data;
    };


return {
        init:init
    }
}) (jQuery);

$(document).ready(function() {
    if ( $('#jp-hearts-tire-search-maker-selector').length ) {
        JpHeartsTireSearchJs.init();
    }
});
